import styled from '@emotion/styled';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import AnyfeedButton from '@unicons-comp/AnyfeedButton/AnyfeedButton';
import Link from 'next/link';
import React from 'react';

interface AnyfeedViewAllProps {
  sectionId: string;
}

const ViewAllWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: ${Spacings.SPACING_6B};
`;

const StyledButton = styled(AnyfeedButton)`
  font-size: ${Fonts.H4};
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.H6};
  }
  &:hover {
    box-shadow: none;
    transform: none;
  }
`;

const AnyfeedViewAll: React.FC<AnyfeedViewAllProps> = ({ sectionId }) => {
  return (
    <ViewAllWrapper>
      <Link href={`/icons/feed/${sectionId}`} passHref>
        <StyledButton
          titleColor="var(--color-i-icon-light-tertiary)"
          backgroundColor="var(--color-i-all-black)"
          title="See all"
        />
      </Link>
    </ViewAllWrapper>
  );
};

AnyfeedViewAll.displayName = 'AnyfeedViewAll';

export default AnyfeedViewAll;
